import NotificationMarker from './NotificationMarker.component';

export default NotificationMarker;
